import type { Part, PropertyConfigCode } from "@/features/sub-families/types";
import { getSelectedFinishingColours } from "@/features/sub-families/utils/colours.ts";
import { useAppSelector } from "@/redux/store.ts";
import { LABEL_DELIMITER } from "@/resources/constants.ts";
import { typedObjectEntries } from "@/utils/types.ts";

export default function useSelectedFinishingColoursLabel() {
    const smartNumberMapping = useAppSelector((state) => state.smartNumber.mapping);
    const parts = useAppSelector((state) => state.parts.items);
    const allowAllParts = useAppSelector((state) => state.parts.allowAllParts);

    const finishingColours = getSelectedFinishingColours(smartNumberMapping);
    const colours = new Set(Object.values(finishingColours));

    // All parts have the same colour applied
    if (colours.size === 1 && allowAllParts) {
        const allPartsLabel = "All parts";
        const colour = Array.from(colours.values())[0];

        const colourLabel = getColourLabel(colour, parts[0]); //Use the first part since this colour should be present on that part too
        if (!colourLabel) return null;

        return `${allPartsLabel} ${colourLabel}`;
    } else {
        const colourLabels: string[] = [];
        for (const [partNo, colour] of typedObjectEntries(finishingColours)) {
            const currentPart = parts.find((part) => part.partNo === partNo);
            if (!currentPart) continue;

            const colourLabel = getColourLabel(colour, currentPart);
            if (colourLabel !== null) colourLabels.push(`${currentPart.label} ${colourLabel}`);
        }

        return colourLabels.join(LABEL_DELIMITER);
    }
}

const getColourLabel = (colour: PropertyConfigCode, part: Part) => {
    const currentColour = part.colors.find((color) => color.code === colour);

    return currentColour?.colourId ?? null;
};
